
Component({
  options: {
    pureDataPattern: /^_/ // 指定所有 _ 开头的数据字段为纯数据字段
  },
  properties: {
    // 控制组件显示隐藏，默认false
    show: {
      type: Boolean,
      value: false
    },
    // 用户唯一标识
    openId: {
      type: String,
      value: ''
    },
    // 组件额外信息
    extraInfo: {
      type: Object,
      value: {}
    }
  }
  // data: {},
  // lifetimes: {},
  // observers: {},
  // methods: {}
})
